// @flow
/** @jsx jsx */

import { jsx } from '@emotion/core';

import type { Node } from 'react';

type Props = {
  children: Node,
};

const invisibleContentCss = {
  height: 1,
  left: -10000,
  overflow: 'hidden',
  position: 'absolute',
  top: 'auto',
  width: 1,
};

const InvisibleContent = ({ children }: Props) => (
  <div css={invisibleContentCss}>{children}</div>
);

export default InvisibleContent;
